import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function DebugPage() {
  const location = useLocation()

  useEffect(() => {
    console.log('FULL URL:', window.location.href)

    console.log('PATHNAME:', location.pathname)

    console.log('QUERY:', location.search)

    const params = new URLSearchParams(location.search)

    console.log('PARAMS:', Object.fromEntries(params.entries()))

    console.log('HASH:', location.hash)

    console.log('LOCAL STORAGE:', {
      token: localStorage.getItem('token'),
    })

    console.log('SESSION STORAGE:', {
      state: sessionStorage.getItem('state'),
    })
  }, [location])

  const params = new URLSearchParams(location.search)

  return (
    <div style={{ padding: 30 }}>
      <h1>Redirect Debug</h1>

      <h3>Full URL</h3>
      <pre>{window.location.href}</pre>

      <h3>Params</h3>
      <pre>{JSON.stringify(Object.fromEntries(params.entries()), null, 2)}</pre>

      <h3>Hash</h3>
      <pre>{location.hash}</pre>
    </div>
  )
}
